<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-sm-12">
          <div class="element-box mb-0">
            <form @submit="refresh">
              <h5 class="form-header">Inventario por Proveedor</h5>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.proveedor &&
                          current.errors.proveedor.length > 0,
                      }"
                    ></label>
                    <ProveedoresSelectComponent
                      :current="current"
                    ></ProveedoresSelectComponent>
                    <small
                      v-if="current.errors && current.errors.proveedor"
                      class="form-text text-danger"
                      >{{ current.errors.proveedor[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-md-12">
                  <TiendaSelectComponent
                    :current="current"
                    incluir_en_blanco="incluir_en_blanco"
                  />
                </div>
              </div>
              <div class="form-buttons-w">
                <button class="btn btn-md btn-success" type="submit">
                  Refrescar
                </button>
                <router-link
                  v-if="current.producto"
                  class="btn btn-outline-info"
                  :to="{
                    name: 'cat-productos-editar',
                    params: { sku: current.producto.sku },
                  }"
                >
                  <i class="fa fa-arrow-left"></i>
                  Ir al Producto
                </router-link>
              </div>
            </form>

            <div class="row">
              <div class="col-sm-12"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="element-wrapper">
            <div class="element-box">
              <br />
              <button
                type="button"
                v-if="datos"
                @click="imprimir(current)"
                class="btn btn-secondary btn-sm btn-block"
              >
                <span>Descargar en Excel</span>
              </button>
              <br />
              <br />
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Tienda</th>
                      <th>Sku</th>
                      <th>Descripcion</th>
                      <th class="text-right">Cantidad</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in datos" :key="item.id">
                      <td>{{ item.tienda_id }} - {{ item.tienda_nombre }}</td>
                      <td>
                        <router-link
                          :to="{
                            name: 'inventario-reportes-kardex',
                            params: {
                              sku: item.sku,
                              tienda: item.tienda_id,
                            },
                          }"
                        >
                          <i class="fa fa-list-ol"></i>&nbsp;
                          <span>{{ item.sku }}</span>
                        </router-link>
                      </td>
                      <td>{{ item.nombre_producto }}</td>
                      <td class="text-right">{{ item.cantidad }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import ProductoTiendaTableComponent from "@/components/cat/productos/ProductoTiendaTableComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProductoUnidadMedidaSelectComponent,
    ProveedoresSelectComponent,
    ProductoTiendaTableComponent,
  },
  data() {
    return {
      incluir_en_blanco: true,
      current: {
        producto: null,
        fecha_final: null,
        fecha_inicial: null,
        tienda: null,
        errors: {
          productos: null,
          fecha_inicial: null,
          fecha_final: null,
        },
      },
      datos: "",
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.tienda) {
        this.current.tienda = this.$route.params.tienda;
        this.refresh();
      }
    },
  },
  mounted() {
    let self = this;
    if (this.$route.params.tienda) {
      self.current.tienda = this.$route.params.tienda;
    }
  },
  methods: {
    imprimir(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      if (current.proveedor != null) {
        current.prov = current.proveedor.codigo;
      }
      if (current.tienda != null) {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_format=xls&report_name=compras/inventario_proveedor/Inventario_proveedor.jrxml&proveedorid=${current.prov}&tiendaid=${current.tienda}`
        );
      } else {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_format=xls&report_name=compras/inventario_proveedor/Inventario_proveedor.jrxml&proveedorid=${current.prov}`
        );
      }
    },
    onChangeProducto(producto) {
      let self = this;
      self.refreshProducto(self.current.producto.sku);
      // self.refreshUnidadMedida(producto);
    },
    refresh(e) {
      if (e) {
        e.preventDefault();
      }
      let self = this;
      let params = {};
      if(typeof(self.current.tienda) == 'string'){
        if (self.current.tienda === 'null'){
          self.current.tienda = null;
        }
      }
      
      if (self.current.tienda) {
        params.tienda = self.current.tienda;
      }
      DynamicService.getAction(
        "cat",
        "proveedores",
        self.current.proveedor.codigo,
        "existencias_de_productos",
        params
      )
        .then((res) => {
          self.datos = res.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>
